import { Dispatch } from "redux";
import { getEnvConfig } from 'kmstack-shared/utils';
import {
    apiRequest, APIResponse, APIServiceBase,
    dispatchIfAvailable, HTTPStatus, resetRedux
} from "kmstack-shared";

export class AuthService extends APIServiceBase {
    static isLoggingOut = false;

    static async logout(dispatch?: Dispatch): Promise<APIResponse> {
        this.isLoggingOut = true;
        try {
            const res = await apiRequest('/auth/logout');
            if (res.status === HTTPStatus.OK && !res.error) {
                dispatchIfAvailable(resetRedux(), dispatch);
                window.location.replace(`${getEnvConfig().accountUrl.replace(/\/$/, '')}/login`);
            }
            return res;
        } finally {
            this.isLoggingOut = false;
        }
    }


}
